import { foundationStepperTabStyles } from '@genesislcap/foundation-ui';
import { css } from '@microsoft/fast-element';
export const zeroStepperTabStyles = (context, definition) => css `
  ${foundationStepperTabStyles(context, definition)}

  zero-tree-item {
    --design-unit: 2.5;
    --neutral-fill-stealth-rest: var(--neutral-layer-3);
    --neutral-fill-stealth-hover: var(--fill-color);
    --neutral-fill-rest: var(--fill-color);
    --base-height-multiplier: 14.5;

    border-bottom: 1px solid var(--fill-color);
  }
`;
